import React from 'react';
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Link,
} from '@mui/material';

const AccountDeletion = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ margin: '2rem auto' }}>
        <Card elevation={3}>
          <CardContent sx={{ padding: '3rem' }}>
            <Typography variant="h4" gutterBottom align="center">
              Account Deletion Policy
            </Typography>

            <Typography variant="body1" paragraph>
              At <strong>JeevaAmirdham</strong>, we respect your right to privacy and give you full control over your account. This page explains how you can request the deletion of your account and personal data associated with our platform.
            </Typography>

            <Typography variant="h5" gutterBottom>
              1. App/Developer Name
            </Typography>
            <Typography variant="body1" paragraph>
              <strong>App Name:</strong> JeevaAmirdham <br />
              <strong>Developer:</strong> JeevaAmirdham.org
            </Typography>

            <Typography variant="h5" gutterBottom>
              2. How to Delete Your Account
            </Typography>
            <Typography variant="body1" paragraph>
              You can delete your account directly from the JeevaAmirdham app or website dashboard:
            </Typography>
            <List>
              <ListItem>
                <ListItemText
                  primary={
                    <Link
                      href="https://www.jeevaamirdham.org/dashboard?tab=5"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://www.jeevaamirdham.org/dashboard?tab=5
                    </Link>
                  }
                  secondary="Log in to your account and click the 'Delete Account' button."
                />
              </ListItem>
            </List>

            <Typography variant="body1" paragraph>
              Alternatively, if you cannot access your account, you may request deletion by sending an email to:
              <br />
              <strong>
                <a href="mailto:jeevaamirdhamweb@gmail.com">jeevaamirdhamweb@gmail.com</a>
              </strong>{' '}
              or{' '}
              <strong>
                <a href="mailto:admin@jeevaamirdham.org">admin@jeevaamirdham.org</a>
              </strong>
              . Please include your registered email address or phone number for verification.
            </Typography>

            <Typography variant="h5" gutterBottom>
              3. What Data Will Be Deleted
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Personal information (Name, Email, Phone)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="App preferences and activity history" />
              </ListItem>
            </List>

            <Typography variant="h5" gutterBottom>
              4. What Data May Be Retained
            </Typography>
            <Typography variant="body1" paragraph>
              We may retain certain data for legal, regulatory, or security purposes, including:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Billing records and payment history" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Audit logs and fraud prevention data (if applicable)" />
              </ListItem>
            </List>
            <Typography variant="body1" paragraph>
              This data will be retained for up to <strong>30 days</strong> after account deletion and then permanently erased.
            </Typography>

            <Typography variant="h5" gutterBottom>
              5. Processing Time
            </Typography>
            <Typography variant="body1" paragraph>
              All verified deletion requests are processed within <strong>7 business days</strong>.
            </Typography>

            <Typography variant="h5" gutterBottom>
              6. Contact Us
            </Typography>
            <Typography variant="body1">
              If you have any questions regarding your data or this policy, please contact us:
              <br />
              <strong>JeevaAmirdham</strong>
              <br />
              Email: <a href="mailto:thiruwriter4u@gmail.com">thiruwriter4u@gmail.com</a>
              <br />
              Phone: <a href="tel:+919176564723">+91 9176564723</a>
              <br />
              Address: 11/6, Bharathi 4th Street, N Usman Rd, T. Nagar, Chennai, Tamil Nadu 600017
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default AccountDeletion;
